import { Backdrop, CircularProgress, Container, Divider, Grid } from '@material-ui/core';
import { ArrowBack, Save as SaveIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { InfoMvmAddOutgoingRequest, MvmOutgoingRequest } from '../../interfaces/Mvm';
import MvmStatus from '../../interfaces/MvmStatus';
import MvmApi from '../../services/MvmApi';
import permissions from '../../utils/Permissions';
import MvmOutgoingRequestList from './components/MvmOutgoingRequestList';
import MvmSummary from './components/MvmSummary';
import { useStyles } from './Style';

interface IFormInput {
    mvmNumber: any;
    outgoingRequests: any;
}

const AddMvmOutgoingRequest: React.FC = () => {

    const classes = useStyles()
    const history = useHistory()
    const { t } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const { enqueueSnackbar } = useSnackbar()
    const [mvmId, setMvmId] = useState<number>(0)
    const [mvmNumber, setMvmNumber] = useState<string>('')
    const { user, hasPermission } = useAuth()
    const [circularLoading, setCircularLoading] = useState(false)
    const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>(
        {
            defaultValues: { mvmNumber: {} }
        })

    useEffect(() => {
        if (!hasPermission(permissions.MVM.OutgoingRequest))
            history.replace('NoPermission');
    }, [history, user])

    const onSummaryChange = (data: any) => {

        if (!data) {
            setMvmId(0)
            setMvmNumber('')
            return
        }

        setMvmNumber(data.mvmNumber)

        setMvmId(data.id)

        //Preencher as descricoes de cada item da lista, para ser exibido corretamente na tela (TODO: Isto deveria ficar dentro de MvmOutgoingRequestList.)
        data.outgoingRequests.forEach((x: any) => {
            x['supplierName'] = x['supplierId'] + ' - ' + x['supplierCorporateName'];
            x['requestTypeDescription'] = x['outgoingRequestType'];
        });

        setValue("outgoingRequests", data.outgoingRequests)
    }

    const onSubmit = (data: any) => {
        if (mvmId == 0) {
            enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
            return
        }

        setCircularLoading(true)

        let putObject: InfoMvmAddOutgoingRequest = {
            id: mvmId,
            mvmNumber: mvmNumber,
            outgoingRequests: []
        }
        data.outgoingRequests.forEach((e: any) => {
            let item: MvmOutgoingRequest = {
                id: 0,
                mvmId: mvmId,
                outgoingRequestType: e.outgoingRequestType,
                requestNumber: e.requestNumber,
                supplierId: e.supplierId,
                supplierCorporateName: e.supplierCorporateName,
                invoiceKey: "",
                invoiceNumber: ""
            }
            putObject.outgoingRequests.push(item)
        });

        MvmApi.addMvmOutgoingRequest(putObject)
            .then(() => {
                enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' })
                refreshPage();
            })
    }

    function refreshPage() {
        window.location.reload();
    }

    return (
        <Container maxWidth={false} component="main">

            <PageTitle title={t("titleOutgoingRequestInsert")} />
            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className={classes.rootContent}>
                <form onSubmit={handleSubmit(onSubmit)} >
                    <Divider style={{ marginTop: '10px' }} />
                    <MvmSummary
                        control={control}
                        name={"summary"}
                        onChange={onSummaryChange}
                        setValue={setValue}
                        mvmStatus={[
                            MvmStatus.FLAG_STATUS_PENDING_UNLOAD,
                            MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                            MvmStatus.FLAG_STATUS_PENDING_LOAD,
                            MvmStatus.FLAG_STATUS_PENDING_FINISH_LOAD,
                            MvmStatus.FLAG_STATUS_PENDING_INVOICING]} //RAS, PCM, PEM, PID, PFD, PIC, PSM, PEC, PFA
                        includeProperties={["OutgoingRequests"]}
                    />
                </form>

                {mvmId == 0 ? <></> :
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {<MvmOutgoingRequestList
                                control={control}
                                name={"outgoingRequests"}
                                allowAdd={true}
                                allowDelete={true} />}
                        </Grid>

                        <ButtonUI
                            style={{ marginTop: 15 }}
                            variant="outlined"
                            color="secondary"
                            onClick={() => refreshPage()}
                            startIcon={<ArrowBack />}>
                            {'Voltar '}
                        </ButtonUI>
                        <ButtonUI
                            style={{ marginTop: 15, marginLeft: 15 }}
                            variant="outlined"
                            color="primary"
                            onClick={() => onSubmit(getValues())}
                            startIcon={<SaveIcon />}>
                            {_t("save")}
                        </ButtonUI>
                    </Grid>
                }
            </div>
        </Container>
    )
}
export default AddMvmOutgoingRequest;
